import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

//import { SessionExpiredComponent } from './session-expired/session-expired.component';
import { LMSDatePickerModule } from 'src/app/core/constants/datepicker-adapter';
import { ClientHeaderComponent } from 'src/app/modules/client-header/client-header.component';
import { Mdb5AdaptedModule, MdbModalConfig, MdbNotificationModule } from 'src/lib/mdb5-adapted/public-api';

import { AppUtilityService } from '../app-utility.service';
import {
  LMS_NoPasteDirective, LMS_NoSpecialsDirective, NumbersOnlyDirective, UniquePayslipDirective, UpperCaseInputDirective,
} from './directives';
import { HighlightDirective } from './directives/highlight.directive';
import { LMSSelectOptionDirective } from './directives/lms-selectOption.directive';
import { LoadingSpinModule } from './loaders';
import { NoSpecialCharPipe, UpperCaseSearchListPipe, ZAcurrencyPipe, ZARcurrencyPipe } from './pipes';
import { LmsClientSearchComponent } from './ui';
import { LmsGridviewModule } from './ui/lms-gridview/lms-gridview.module';
import { PageheaderCardModule } from './ui/pageheader-card/pageheader-card.module';
import { SlidePanelModule } from './ui/slide-panel/slide-panel.module';

const EXPORTED_DECLARATIONS = [
  ClientHeaderComponent,
  LmsClientSearchComponent,
  LMSDatePickerModule,
  ZAcurrencyPipe,
  ZARcurrencyPipe,
  NoSpecialCharPipe,
  HighlightDirective,
  UpperCaseSearchListPipe,
  NumbersOnlyDirective,
  LMSSelectOptionDirective,
  LMS_NoPasteDirective,
  UpperCaseInputDirective,
  LMS_NoSpecialsDirective
];

@NgModule({
  imports: [CommonModule, ...EXPORTED_DECLARATIONS,
    SlidePanelModule,
    PageheaderCardModule,
    Mdb5AdaptedModule,
    //ToastModule,
    LmsGridviewModule,
    MdbNotificationModule
  ],
  providers: [
    {
      provide: MdbModalConfig,
      useValue: {
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: true,
        nonInvasive: false,
        animation: true,
        modalClass: 'd-flex',
        containerClass: 'modal show',
      },
    },

    AppUtilityService,
    HighlightDirective,
    NumbersOnlyDirective,
    LMSSelectOptionDirective,
    LMS_NoSpecialsDirective,
    LMS_NoPasteDirective,
    UniquePayslipDirective,
    UpperCaseSearchListPipe,
    ZARcurrencyPipe,
    ZAcurrencyPipe,
    LoadingSpinModule,
  ],
  declarations: [
  ],
  exports:[
    SlidePanelModule,
    PageheaderCardModule,
    LmsGridviewModule,
  ]
  //exports: [
  //       PageCardheadComponent,
  //LmsPaginateComponent,
  //       LmsGridviewComponent,
  //       LMSDialogComponent,
  //       ZAcurrencyPipe,
  //       ZARcurrencyPipe,
  //       HighlightDirective,
  //       NoSpecialCharPipe,
  //       UpperCaseSearchListPipe,
  //       UpperCaseInputDirective,
  //       ClientHeaderComponent,
  //       LmsClientSearchComponent
  // ]
})
export class LMSSharedUiModule {}

// import { CommonModule } from '@angular/common';
// import { NgModule } from '@angular/core';

// import { MdbModalConfig } from 'src/lib/mdb5-adapted/public-api';
// import { NgxPaginationModule } from 'ngx-pagination';
// //import { SessionExpiredComponent } from './session-expired/session-expired.component';
// import { LMSDatePickerModule } from 'src/app/core/constants/datepicker-adapter';
// import { MdbUiKitModule } from 'src/app/mdb-ui-kit.module';
// import { ClientHeaderComponent } from 'src/app/modules/client-header/client-header.component';
// import { LmsGridviewComponent } from 'src/app/shared/ui/lms-gridview/lms-gridview.component';

// import { AppUtilityService } from '../app-utility.service';
// import { LMSDialogComponent } from './dialogs/lms-dialog/lms-dialog.component';
// import {
//   LMS_NoPasteDirective,
//   LMS_NoSpecialsDirective,
//   NumbersOnlyDirective,
//   UniquePayslipDirective,
//   UpperCaseInputDirective,
// } from './directives';
// import { HighlightDirective } from './directives/highlight.directive';
// import { LMSSelectOptionDirective } from './directives/lms-selectOption.directive';
// import { LMSDialogHandlerService } from './lmsdialog-handler.service';
// import { NoSpecialCharPipe, UpperCaseSearchListPipe, ZAcurrencyPipe, ZARcurrencyPipe } from './pipes';
// import { LmsClientSearchComponent } from './ui/lmsclient-search/lmsclient-search.component';
// import { PageCardheadComponent } from './ui/pageheader-card/pageheader-card.component';

// const EXPORTED_DECLARATIONS = [
//   ClientHeaderComponent,
//   PageCardheadComponent,
//   LmsClientSearchComponent,
//   LmsGridviewComponent,
//   LMSDatePickerModule,
//   ZAcurrencyPipe,
//   ZARcurrencyPipe,
//   NoSpecialCharPipe,
//   LMSDialogComponent,
//   HighlightDirective,
//   UpperCaseSearchListPipe,
//   NumbersOnlyDirective,
//   LMSSelectOptionDirective,
//   LMS_NoPasteDirective,
//   UpperCaseInputDirective,
//   LMS_NoSpecialsDirective,
// ];

// @NgModule({
//   imports: [CommonModule, MdbUiKitModule, NgxPaginationModule, ...EXPORTED_DECLARATIONS],
//   providers: [
//     {
//       provide: MdbModalConfig,
//       useValue: {
//         backdrop: true,
//         ignoreBackdropClick: true,
//         keyboard: true,
//         nonInvasive: false,
//         animation: true,
//         modalClass: 'd-flex',
//         containerClass: 'modal show',
//       },
//     },
//     LMSDialogHandlerService,
//     AppUtilityService,
//     HighlightDirective,
//     NumbersOnlyDirective,
//     LMSSelectOptionDirective,
//     LMS_NoSpecialsDirective,
//     LMS_NoPasteDirective,
//     UniquePayslipDirective,
//     UpperCaseSearchListPipe,
//     ZARcurrencyPipe,
//     ZAcurrencyPipe,
//   ],
//   //exports: [
//   //       PageCardheadComponent,
//   //LmsPaginateComponent,
//   //       LmsGridviewComponent,
//   //       LMSDialogComponent,
//   //       ZAcurrencyPipe,
//   //       ZARcurrencyPipe,
//   //       HighlightDirective,
//   //       NoSpecialCharPipe,
//   //       UpperCaseSearchListPipe,
//   //       UpperCaseInputDirective,
//   //       ClientHeaderComponent,
//   //       LmsClientSearchComponent
//   //],
// })
// export class LMSSharedUiModule {}
